import React from 'react';
import useStyles from "../../assets/styles/styles";
import {Box} from "@material-ui/core";
const HomeMedicalBox = ({ children }) => {
    const classes = useStyles();
    return <>
        <Box className={`${classes.homeMedicalBox} ${classes.customScroll}`}>
            {children}
        </Box>
    </>;
};

export default React.memo(HomeMedicalBox);